import { render, staticRenderFns } from "./EditCustomerAddressModal.vue?vue&type=template&id=1d2fbbfa&scoped=true&"
import script from "./EditCustomerAddressModal.vue?vue&type=script&lang=js&"
export * from "./EditCustomerAddressModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerAddressModal.vue?vue&type=style&index=0&id=1d2fbbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fbbfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VTextField})
